import React from 'react';
import { COLORS, FONT } from './tokens';

/*
 * SectionHeader — a heading INSIDE a page: a report's per-shop or per-week block, a form's
 * "Purchase Record" group. Left-aligned title over a hairline; prints cleanly.
 * Replaces the dashed/solid rule with a label box sitting on it.
 */
export default function SectionHeader({ title, right, style }) {
    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
            margin: '24px 0 12px', paddingBottom: 8, borderBottom: `1px solid ${COLORS.border}`, ...style,
        }}>
            <div style={{ fontFamily: FONT, fontSize: 14, fontWeight: 700, color: COLORS.text, minWidth: 0 }}>
                {title}
            </div>
            {right && <div style={{ flexShrink: 0 }}>{right}</div>}
        </div>
    );
}
